<template>
  <el-dialog
    title="Create WeChat Channel"
    width="40%"
    :visible.sync="showDialog"
    append-to-body>

    <div class="dialog-body">
      <el-form :model="wechatChannelForm" ref="wechatChannelForm" :rules="wechatChannelFormRules">
        <el-form-item prop="name" label="WeChat Name">
          <el-input :autofocus="true" v-model="wechatChannelForm.name" />
        </el-form-item>
        <el-form-item prop="token" label="Token">
          <el-input :autofocus="true" v-model="wechatChannelForm.token" />
        </el-form-item>
        <el-form-item prop="token_secret" label="Token Secret">
          <el-input :autofocus="true" v-model="wechatChannelForm.token_secret" />
        </el-form-item>
      </el-form>
    </div>

    <div slot="footer" class="dialog-footer">
      <el-button @click="showDialog = false" plain>Cancel</el-button>
      <el-button 
        type="primary" 
        :disabled="addingWechatChannel"
        @click="handleSaveChannel" 
        plain
      >
        Save
        <i v-if="addingWechatChannel" class="fa fa-spinner fa-pulse"></i>
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import { mapState } from 'vuex';
import { channelTypes } from '@/constants';

export default {
  name: 'WechatChannelCreateDialog',

  data: () => ({
    wechatChannelForm: {
      name: '',
      token: '',
      token_secret: '',
    },
    wechatChannelFormRules: {
      name: [
          { required: true, message: 'WeChat Name is required', trigger: 'blur' },
      ],
      token: [
          { required: true, message: 'Token is required', trigger: 'blur' },
      ],
      token_secret: [
          { required: true, message: 'Token Secret is required', trigger: 'blur' },
      ],
    },
  }),
  props: {
    isVisible: {
      type: Boolean,
      required: true,
    },
  },

  computed: {
    ...mapState('channel', ['addingWechatChannel']),

    showDialog: {
      get() {
        return this.isVisible;
      },

      set(visibility) {
        this.$emit('onVisibleChanged', visibility);
      },
    },
  },

  methods: {
    handleSaveChannel() {
      this.$refs.wechatChannelForm.validate(valid => {
        if (valid) return this.addWechatChannel();
        return false;
      });
    },
    addWechatChannel() {
      const wechatChannel = {
        handle: this.wechatChannelForm.name,
        token: this.wechatChannelForm.token,
        token_secret: this.wechatChannelForm.token_secret,
        channel_type: channelTypes.WE_CHAT,
        live: true,
        extra_data: '',
      };

      this.$store.dispatch('channel/addWechatChannel', wechatChannel).then(() => {
        this.$emit('onWechatChannelAdded');
        this.showDialog = false;
      });
    },
  },

  watch: {
    showDialog() {
      if (this.$refs && this.$refs.wechatChannelForm) {
        this.$refs.wechatChannelForm.resetFields();
      }
    },
  },
};
</script>




// WEBPACK FOOTER //
// WechatChannelCreateDialog.vue?bfbf635a